/** Tailwind line-clamp classes 1–6 (used so JIT includes them). */
const LINE_CLAMP_CLASSES = ['line-clamp-1', 'line-clamp-2', 'line-clamp-3', 'line-clamp-4', 'line-clamp-5', 'line-clamp-6'] as const

/**
 * Returns the Tailwind line-clamp class for the given number of lines, or undefined if not in 1–6.
 */
export function getLineClampClass(truncateAtLine: number | undefined): string | undefined {
  if (truncateAtLine == null || truncateAtLine < 1 || truncateAtLine > 6) return undefined
  return LINE_CLAMP_CLASSES[truncateAtLine - 1]
}
